import { useTranslation } from "react-i18next";
import { Step } from "react-joyride";
import { DomainTypeWhiteLabelEnum } from "../../../types";
import { ContinueEducationTooltip } from "./tooltips/ContinueEducationTooltip";

interface DataStep {
  tooltipWidth?: string;
  hideNextButton?: boolean;
  customContent?: Record<string, string>;
}
interface ExtendedStep extends Step {
  data?: DataStep;
}

const useSteps = () => {
  const { t } = useTranslation();

  const steps: ExtendedStep[] = [
    {
      target: "#project-name",
      content: t("whiteLabelSteps.step0Info"),
      disableBeacon: true,
      hideBackButton: true,
      spotlightPadding: 16,
      spotlightClicks: true,
      offset: 13,
    },
    {
      target: "#project-name",
      title: t("whiteLabelSteps.step1Title"),
      content: t("whiteLabelSteps.step1Info"),
      disableBeacon: true,
      hideBackButton: true,
      spotlightPadding: 16,
      tooltipComponent: ContinueEducationTooltip,
      offset: 13,
    },
    {
      target: "#main-page-blocks",
      content: t("whiteLabelSteps.step2Info"),
      disableBeacon: true,
      spotlightPadding: 16,
      spotlightClicks: true,
      offset: 13,
    },
    {
      target: "#seo-info",
      content: t("whiteLabelSteps.step3Info"),
      disableBeacon: true,
      spotlightPadding: 24,
      spotlightClicks: true,
      data: {
        hideNextButton: true,
      },
      showSkipButton: true,
      offset: 30,
    },
    {
      target: "#social-links",
      content: t("whiteLabelSteps.step4Info"),
      disableBeacon: true,
      spotlightPadding: 24,
      spotlightClicks: true,
      hideFooter: true,
      offset: 30,
    },
    {
      target: "#subdomain",
      content: t("whiteLabelSteps.step5Info"),
      disableBeacon: true,
      spotlightPadding: 24,
      spotlightClicks: true,
      hideFooter: true,
      placement: "right",
      offset: 30,
      data: {
        customContent: {
          [DomainTypeWhiteLabelEnum.MyDomain]: t(
            "whiteLabelSteps.step5DomainInfo"
          ),
          [DomainTypeWhiteLabelEnum.MySubDomain]: t(
            "whiteLabelSteps.step5SubDomainInfo"
          ),
        },
      },
    },
    {
      target: "#subdomain",
      content: t("whiteLabelSteps.step6Info"),
      disableBeacon: true,
      spotlightPadding: 24,
      spotlightClicks: false,
      hideBackButton: true,
      placement: "right",
      offset: 30,
    },
    {
      target: "#add-domain",
      content: t("whiteLabelSteps.step7Info"),
      disableBeacon: true,
      spotlightPadding: 24,
      spotlightClicks: true,
      hideFooter: true,
      placement: "right",
      offset: 30,
    },
    {
      target: "#add-domain",
      content: t("whiteLabelSteps.step8Info"),
      disableBeacon: true,
      spotlightPadding: 24,
      spotlightClicks: true,
      hideFooter: true,
      placement: "right",
      offset: 30,
    },
    {
      target: "#add-domain",
      content: t("whiteLabelSteps.step9Info"),
      disableBeacon: true,
      spotlightPadding: 24,
      spotlightClicks: true,
      hideFooter: true,
      placement: "right",
      offset: 30,
    },
    {
      target: "#subdomain",
      content: t("whiteLabelSteps.step10Info"),
      disableBeacon: true,
      spotlightPadding: 24,
      spotlightClicks: false,
      placement: "right",
      hideBackButton: true,
      offset: 30,
    },
    {
      target: "#media-design",
      content: t("whiteLabelSteps.step11Info"),
      disableBeacon: true,
      spotlightPadding: 24,
      spotlightClicks: true,
      hideFooter: true,
      placement: "right",
      offset: 30,
    },
  ];

  return { steps };
};

export default useSteps;
